import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import i18n from "@/plugins/i18n";
import VueAuth from "@/plugins/auth";
import VueAxios from "@/plugins/axios";
import valueFormatCurrency from "@/plugins/value-format-currency";
import valueFormatCurrencyCode from "@/plugins/value-format-currency-code";
import "@/plugins/vuenoty";
import "@/plugins/vuemoment";
import "@/plugins/veevalidate";
import "@/App.css";
import 'vue-json-pretty/lib/styles.css';

window.axios = VueAxios;

Vue.config.productionTip = false;

Vue.use(VueAuth);
Vue.use(valueFormatCurrency);
Vue.use(valueFormatCurrencyCode);

window.app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
